/**
 * Como se le muestra la disponibilidad al comprador (CAT-02).
 *
 * Un producto agotado no desaparece del catalogo: se marca. Y el numero que se
 * muestra es el que informo Random en la ultima sincronizacion; el sitio nunca
 * inventa un stock.
 */
import { Icono } from './Icono';

/** Bajo esta cantidad se muestra la urgencia en vez del numero a secas. */
const STOCK_CRITICO = 4;

export interface EtiquetaStockProps {
  stock: number;
}

export function EtiquetaStock({ stock }: EtiquetaStockProps) {
  if (stock <= 0) {
    return (
      <span className="etq etq-critico">
        <span className="punto" />
        Sin stock
      </span>
    );
  }

  if (stock <= STOCK_CRITICO) {
    return (
      <span className="etq etq-alerta">
        <span className="punto" />
        Quedan {stock}
      </span>
    );
  }

  return (
    <span className="etq etq-ok">
      <Icono nombre="check" />
      En stock
    </span>
  );
}
